export default "__VITE_ASSET__rnJXID3V__"